module.exports = __webpack_public_path__ + "img/abstract_2.bb76bd04.png";